import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FeatureSubscriptionPaymentCycle, FeatureSubscriptionProductCode } from 'queries';

import { CardButton } from './card-button';
import { CardButtonGroup } from './card-button-group';

type Props = {
  currentPlan?: FeatureSubscriptionProductCode | null;
  isUpdating: boolean;
  handlePayCycleOnClick: Function;
  order: number;
  selectedPlan: FeatureSubscriptionProductCode | null;
  selectedPayCycle: FeatureSubscriptionPaymentCycle;
};

const useStyles = makeStyles(() => ({
  gridContainer: {
    marginLeft: '30px',
    marginBottom: '75px',
  },
  gridItem: {
    padding: '0px',
    margin: '10px',
  },
  listNumber: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ddd',
    borderRadius: '50%',
    width: '25px',
    height: '25px',
    marginRight: '15px',
  },
  orderedListContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '10px',
  },
  pageContainer: {
    margin: '15px',
  },
}));

export const PayCycleSelection = ({
  handlePayCycleOnClick,
  isUpdating,
  order,
  selectedPlan,
  selectedPayCycle,
}: Props) => {
  const classes = useStyles();

  const getSelectedOption = () => {
    return selectedPayCycle === FeatureSubscriptionPaymentCycle.Yearly
      ? 1
      : selectedPayCycle === FeatureSubscriptionPaymentCycle.Monthly
        ? 2
        : 0;
  };

  return (
    <>
      {!isUpdating && (
        <>
          <div className={classes.orderedListContainer}>
            <Typography className={classes.listNumber}>{order}</Typography>
            <Typography variant="h6">Choose your subscription cycle</Typography>
          </div>
          <Grid container direction="row" spacing={2} className={classes.gridContainer}>
            <CardButtonGroup defaultSelected={getSelectedOption()}>
              <Grid item alignItems="center" className={classes.gridItem}>
                <CardButton
                  payCycle={FeatureSubscriptionPaymentCycle.Yearly}
                  id={1}
                  title="Annually"
                  showChip={false}
                  handleOnClick={handlePayCycleOnClick}
                  productCode={selectedPlan}
                />
              </Grid>
              <Grid item alignItems="center" className={classes.gridItem}>
                <CardButton
                  payCycle={FeatureSubscriptionPaymentCycle.Monthly}
                  id={2}
                  title="Monthly"
                  showChip={false}
                  handleOnClick={handlePayCycleOnClick}
                  productCode={selectedPlan}
                />
              </Grid>
            </CardButtonGroup>
          </Grid>
        </>
      )}
    </>
  );
};
